/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SourceContact } from './SourceContact';
import {
    SourceContactFromJSON,
    SourceContactFromJSONTyped,
    SourceContactToJSON,
} from './SourceContact';

/**
 * 
 * @export
 * @interface FindAllSourceContactsResponse
 */
export interface FindAllSourceContactsResponse {
    /**
     * 
     * @type {Array<SourceContact>}
     * @memberof FindAllSourceContactsResponse
     */
    data: Array<SourceContact>;
    /**
     * 
     * @type {number}
     * @memberof FindAllSourceContactsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllSourceContactsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllSourceContactsResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllSourceContactsResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllSourceContactsResponse interface.
 */
export function instanceOfFindAllSourceContactsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllSourceContactsResponseFromJSON(json: any): FindAllSourceContactsResponse {
    return FindAllSourceContactsResponseFromJSONTyped(json, false);
}

export function FindAllSourceContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceContactsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SourceContactFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllSourceContactsResponseToJSON(value?: FindAllSourceContactsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(SourceContactToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

